module.exports = __webpack_public_path__ + "static/media/privacy.1746c217.pdf";